<template>
  <div class="pop_wrapper">
    <div class="popup_cover"></div>
    <div class="alert_wrapper">
      <div class="alert_header">
        <div class="alert_title" v-html="props.title"></div>
      </div>
      <div class="alert_body">
        <div class="alert_text" v-html="props.msg"></div>
      </div>

      <div v-if="props.type == 'alert'" class="alert_footer">
        <div class="alert_confirm" @click="alertOk">확인</div>
      </div>
      <div v-if="props.type == 'confirm'" class="alert_footer">
        <div class="alert_confirm" @click="alertOk">확인</div>
        <div class="alert_cancel" @click="closeAlert">취소</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// import { defineProps } from "vue";
import { defineProps } from "vue";
import { useStore } from "vuex";
const store = useStore();
const props = defineProps<{
  title: string;
  msg: string;
  type: string;
  sCb: any;
  fCb: any;
}>();
// store.commit("closeAlert");
const alertOk = () => {
  if (props.sCb != undefined && props.sCb != null) {
    window.setTimeout(() => {
      props.sCb();
    }, 300);
  }
  closeAlert();
};
const closeAlert = () => {
  if (props.fCb != undefined && props.fCb != null) {
    props.fCb();
  }
  store.commit("closeAlert");
};

//  window.customConfirm({
//           title: "로그인에러",
//           msg: "입력한 아이디 또는 비밀번호가 틀립니다. 다시 입력해주시기 바랍니다.",
//           sCb: function () {
//             loginInfo.value.password = "";
//             pwInput.value.focus();
//           },
//           fCb: function () {
//             loginInfo.value.password = "";
//             pwInput.value.focus();
//           },
//         });
</script>

<style>
.pop_wrapper {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 100;
}
.alert_wrapper {
  position: absolute;
  width: 312px;
  min-height: 167px;
  padding: 16px;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #dbdbdb;
  /* box-shadow: 10px 5px 5px #dbdbdb; */
  box-sizing: border-box;
  right: calc(50% - 156px);
  top: calc(50% - 83px);
  z-index: 1010;
}
.alert_header {
  margin-bottom: 16px;
}
.alert_title {
  height: 27px;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  color: #1d1d1d;
  font-family: "Noto Sans CJK KR-Medium";
  font-weight: bold;
}
.alert_body {
  margin-bottom: 16px;
}
.alert_text {
  min-height: 34px;
  line-height: 17px;
  font-size: 13px;
  text-align: center;
  color: #343434;
  font-family: "Noto Sans CJK KR-Regular";
  word-break: keep-all;
}
/* .alert_confirm {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #677fff;
  border-radius: 8px;
  color: #ffffff;
  font-family: 'Noto Sans CJK KR-Medium';
  font-size: 14px;
  cursor: pointer;
} */
.alert_footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.alert_confirm {
  width: 85px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #006da1;
  border-radius: 8px;
  color: #ffffff;
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 14px;
  box-sizing: border-box;
  cursor: pointer;
}
.alert_cancel {
  width: 85px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 8px;
  color: #888888;
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 14px;
  box-sizing: border-box;
  cursor: pointer;
}
</style>
